import { render, staticRenderFns } from "./FieldReassignmentAuditTrailItem.vue?vue&type=template&id=a23150e8&"
import script from "./FieldReassignmentAuditTrailItem.vue?vue&type=script&lang=ts&"
export * from "./FieldReassignmentAuditTrailItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports